const Limit = () =>
  import(
    /* webpackChunkName: "security-limit" */ '@/pages/security/limit/index.vue'
  )
const Detail = () =>
  import(
    /* webpackChunkName: "security-limit" */ '@/pages/security/limit/detail.vue'
  )
const CreateLimit = () =>
  import(
    /* webpackChunkName: "security-limit" */ '@/pages/security/limit/create.vue'
  )
const EditLimit = () =>
  import(
    /* webpackChunkName: "security-limit" */ '@/pages/security/limit/edit.vue'
  )

export default {
  path: 'limit',
  meta: {
    label: 'limit',
    auth: 'limit'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SecurityLimitReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Limit
    },
    {
      name: 'SecurityLimitDetail',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'detail'
      },
      component: Detail,
      props: true
    },
    {
      name: 'SecurityCreateLimit',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateLimit
    },
    {
      name: 'SecurityEditLimit',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditLimit,
      props: true
    }
  ]
}
